import { useTranslation } from 'react-i18next';
import { FormInput } from '@unified-checkout/kit-components';

export function CardHolder(props: any) {
  const { customStyle, formRegister, maxLength, error, className, placeholder } =
    props;
  const { t } = useTranslation('card');

  return (
    <FormInput
      name={'name'}
      error={error}
      className={className}
      placeholder={placeholder || "ex. Abdullah Adel"}
      formRegister={formRegister}
      maxLength={maxLength}
      autoComplete="cc-name"
      customStyle={customStyle}
    />
  );
}
